module.exports = __webpack_public_path__ + "css/theme/default.css";


//////////////////
// WEBPACK FOOTER
// ./plugins/Admin/build/style/theme/default.css
// module id = 61
// module chunks = 0